import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/course/exchange/page',
    add:'/api-ir/bachelor/course/exchange/add',
    update:'/api-ir/bachelor/course/exchange/edit',
    info:'/api-ir/bachelor/course/exchange/info/',
    del:'/api-ir/bachelor/course/exchange/delete/',
    approve:'/api-ir/bachelor/course/exchange/approve1',
    export:'/api-ir/bachelor/course/exchange/export/',
}
// 查询列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 审批课程
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}

//导出
export function exportFile (id) {
    return baseAPI.axiosData(api.export+id,'get')
}